import { clientFactory } from './factories';
import { AuthenticationModuleGoogleClient } from './implementations/google/client';
import { AuthenticationModuleMockedClient } from './implementations/mocked/client';

export const AuthenticationModuleClient = clientFactory(
  process.env.NEXT_PUBLIC_MOCK_AUTHENTICATION === 'true'
    ? AuthenticationModuleMockedClient
    : AuthenticationModuleGoogleClient
);
